module.exports = __webpack_public_path__ + "static/media/templar_assassin.6ad1d9fe.png";